/* receipt/actions */
import { action } from "typesafe-actions";
import { Data, Receipt, ReceiptActionTypes } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(ReceiptActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Receipt) =>
  action(ReceiptActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(ReceiptActionTypes.FETCH_ERROR, error);


export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Receipt | null) => unknown
) => action(ReceiptActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Receipt) =>
  action(ReceiptActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(ReceiptActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(ReceiptActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(ReceiptActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) => action(ReceiptActionTypes.DELETE_ERROR, error);
